import { render, staticRenderFns } from "./wlsbCov.vue?vue&type=template&id=c6124914&scoped=true"
import script from "./wlsbCov.vue?vue&type=script&lang=js"
export * from "./wlsbCov.vue?vue&type=script&lang=js"
import style0 from "./wlsbCov.vue?vue&type=style&index=0&id=c6124914&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6124914",
  null
  
)

export default component.exports